import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ps-4 my-4"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "table table-striped" }
const _hoisted_5 = { class: "total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.isWeastagePercentageGSMVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            type: "h5",
            localizedKey: "Waste Generation",
            text: "Waste Generation"
          })
        ]),
        _hoisted_3,
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Fabric",
                  text: "Fabric"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Grams",
                  text: "Grams"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "gCO2",
                  text: "gCO2"
                })
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.processByLayerName), (layerName, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: layerName }, [
                _createElementVNode("td", null, _toDisplayString(layerName), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(
                                _ctx.getTotalByLayer("wastageGrams", layerName) 
                            )), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(
                                _ctx.getTotalByLayer("wastageCO2", layerName) 
                            )), 1)
              ]))
            }), 128)),
            _createElementVNode("tr", _hoisted_5, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Total",
                    text: "Total"
                  })
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(
                            _ctx.getTotal("wastageGrams")
                        )), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(
                            _ctx.getTotal("wastageCO2")
                        )), 1)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}